var _circle, _line, _line2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2c3e50",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3498db",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 120,
    fill: "url(#logoGradient)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 100,
    x2: 210,
    y2: 100,
    stroke: "white",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 190,
    x2: 210,
    y2: 190,
    stroke: "white",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 170,
    fontFamily: "Arial, sans-serif",
    fontSize: 70,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "\n    RWC\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReedLogo);
export default __webpack_public_path__ + "static/media/reed-logo.4364dcfb94ed831c2689c07312f24288.svg";
export { ForwardRef as ReactComponent };